module.exports = __webpack_public_path__ + "static/img/hero-land-logo.fe48e640.png";